
const Index = r => require.ensure([], () => r(require('./index.vue')), 'assessment')
const assessmentHome = r => require.ensure([], () => r(require('./assessmentHome.vue')), 'assessment')
const Hearing = r => require.ensure([], () => r(require('./hearing.vue')), 'assessment')
const Recording = r => require.ensure([], () => r(require('./recording.vue')), 'assessment')
const Reading = r => require.ensure([], () => r(require('./reading.vue')), 'assessment')
const AnswerResult = r => require.ensure([], () => r(require('./answerResult.vue')), 'assessment')

const Writing = r => require.ensure([], () => r(require('./writing.vue')), 'assessment')
const Load = r => require.ensure([], () => r(require('./components/Load.vue')), 'assessment')
export default {
  path: '/assessment',
  component: Index,
  children: [
    {
      meta: {
        title: '语言测评系统'
      },
      path: "home",
      name: 'home',
      component: assessmentHome
    },
    {
      meta: {
        title: '英语水平测评'
      },
      path: "hearing",
      name: 'hearing',
      component: Hearing
    },
    {
      meta: {
        title: '英语水平测评'
      },
      path: "recording",
      name: 'recording',
      component: Recording
    },
    {
      meta: {
        title: '英语水平测评'
      },
      path: "reading",
      name: 'reading',
      component: Reading
    },
    {
      meta: {
        title: '语言测评结果'
      },
      path: "answerResult",
      name: 'answerResult',
      component: AnswerResult
    },
    {
      meta: {
        title: '英语水平测评'
      },
      path: "writing",
      name: 'writing',
      component: Writing
    },
    {
      meta: {
        title: '系统正在为您评分'
      },
      path: "load",
      name: 'load',
      component: Load
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/assessment/router.js